<template>
  <div>
    <div class="text-center" v-if="!dataLoaded">
      <v-progress-circular class="mt-6" :size="50" color="primary" indeterminate />
    </div>

    <div class="mt-4" v-else>
      <v-row class="my-0">
        <v-col cols="12" class="pt-0">

          <v-row>
            <v-col cols="12" md="7" class="d-flex">
              <v-btn
                outlined small rounded
                color="primary"
                class="white--text px-4"
                @click="dialog = true"
              >
                <v-icon left small>mdi-plus</v-icon>Добавить
              </v-btn>
            </v-col>
          </v-row>

          <PageTable
            :table-loading="tableLoading"
            :table-headers="tableHeaders"
            :table-items="protocols.list"
            filter single-expand single-select show-expand
            @showItemExpanded="showProtocolLines"
          >
            <template v-slot:expanded-item="{ headers, item: protocol }">
              <td :colspan="headers.length">
                <v-data-table
                  class="protocols-table_inner py-2 ma-2"
                  :headers="applicationHeaders"
                  :items="currentProtocolApplications.list"
                  :loading="protocolLinesLoading"
                  dense hide-default-footer
                  loading-text="Загрузка"
                  no-data-text="заявлений в протокол не добавлено"
                  item-key="id"
                />
              </td>
            </template>

            <template v-slot:item.actions="{ item }">
<!--              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Загрузка протокола" @click="downloadReport(item, $event)">
                mdi-download
              </v-icon>-->
<!--              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Загрузка выписки из протокола" @click="downloadExtractReport(item, $event)">
                mdi-file-download-outline
              </v-icon>-->
              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Рейтинговые баллы" @click="addProtocolLine(item)">
                mdi-file-document-edit-outline
              </v-icon>
              <v-icon color="lightGrey" class="mr-1 edit-btn" size="22" title="Редактировать" @click="edit(item)">
                mdi-pencil-outline
              </v-icon>
              <v-icon color="lightGrey" class="remove-btn" size="22" title="Удалить" @click="remove(item)">
                mdi-trash-can-outline
              </v-icon>
            </template>
          </PageTable>

        </v-col>
      </v-row>
    </div>

    <ConfirmDialog
      :dialog="confirmDialog"
      :loading="btnLoading"
      :message="`Вы уверены, что хотите удалить значение из справочника?`"
      @confirm="removeProtocol"
      @closeModal="closeDialog"
    />

    <ProtocolDialog
      :dialog="dialog"
      :loading="btnLoading"
      :selectedItem="selectedItem"
      @saveProtocol="saveProtocol"
      @closeModal="closeDialog"
    />
  </div>
</template>

<script>
import {curatorApi, protocolApi, protocolLineApi, reportControllerApi} from '@/api'
import { mapGetters } from 'vuex'
import {Protocol, ProtocolParent, ProtocolLine, ProtocolLineDtoList} from '@/models'
import PageTable from '@/components/ui/Table'
import ProtocolDialog from '@/components/zvp/documentationSetup/dialogs/Protocol'
import ConfirmDialog from '@/components/dialogs/ConfirmDelete'
import download from '@/plugins/download'
import { getReverseDate } from '@/scripts/formatDate'

export default {
  name: 'Protocols',

  components: {
    PageTable,
    ProtocolDialog,
    ConfirmDialog,
  },

  async created() {
    await this.$store.dispatch('user/getCurrent')
    await this.getProtocolList()
    this.dataLoaded = true
  },

  data: () => ({
    tableHeaders: [
      { text: 'Номер', value: 'protocolNumber', sortable: false, align: 'start' },
      { text: 'Дата протокола', value: 'protocolDateText', sortable: false, align: 'start'},
      { text: 'Действия', value: 'actions', sortable: false, align: 'center', width: '160px' },
      { text: '', value: 'data-table-expand' },
    ],
    protocols: new ProtocolParent(),
    applicationParamDto: new ProtocolLine(),
    tableLoading: false,
    selectedItem: null,
    confirmDialog: false,
    isShowMode: false,
    btnLoading: false,
    dataLoaded: false,
    dialog: false,
    rangingDialog: false,
    protocolLinesLoading: false,

    applicationHeaders: [
      { text: 'ФИО', value: 'fullName', sortable: false, align: 'start'},
      { text: 'Результат тестирования', value: 'testScore', sortable: false, align: 'start'},
      { text: 'Курс', value: 'courseNumberTo.name', sortable: false, align: 'start'},
      { text: 'Основа обучения', value: 'paidFormTo.name', sortable: false, align: 'start'},
      { text: 'Специальность', value: 'specialityTo.name', sortable: false, align: 'start'},
      { text: 'Тип заявления', value: 'applicationType.name', sortable: false, align: 'start'},
      { text: 'Решение', value: 'decision.name', sortable: false, align: 'start'},
    ],
    currentProtocolApplications: new ProtocolLineDtoList(),
  }),

  computed: {
    ...mapGetters('user', ['isCurator', 'isAdmin']),

    checkRoles() {
      return this.isCurator || this.isAdmin
    },
  },

  methods: {
    async getProtocolList() {
      try {
        this.tableLoading = true
        if (this.checkRoles) {
          const data = await protocolApi.getCatalog()
          if (data.length) data.forEach(obj => this.protocols.addProtocol(obj))
        }
      } catch (e) {
        this.showErrorMessage(e, 'Возникла ошибка')
      } finally {
        this.tableLoading = false
      }
    },

    addProtocolLine(item) {
      this.$router.push(`/zvp/documentation-setup/protocol-line/${item.id}`)
    },

    async downloadReport(item, event) {
      event.target.classList.add('mdi-loading')
      try {
      //  const data = await reportControllerApi.getProtocolReport(item.id)
     //   data && download(data, 'Report.pdf')
      }
      catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      }
      finally {
        event.target.classList.remove('mdi-loading')
      }
    },

    async downloadExtractReport(item, event) {
      event.target.classList.add('mdi-loading')
      try {
      //  const data = await reportControllerApi.getProtocolExtractReport(item.id)
     //   data && download(data, 'ExtractReport.pdf')
      }
      catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки')
      }
      finally {
        event.target.classList.remove('mdi-loading')
      }
    },

    edit(item) {
      this.selectedItem = item.getForAPI()
      this.selectedItem.protocolDate = getReverseDate(this.selectedItem.protocolDate)
      this.dialog = true
    },

    remove(item) {
      this.selectedItem = item.getForAPI()
      this.selectedItem.protocolDate = getReverseDate(this.selectedItem.protocolDate)
      this.confirmDialog = true
    },

    async saveProtocol(body) {
      try {
        this.btnLoading = true

        const data = body.id ? await protocolApi.update(body) : await protocolApi.create(body)
        body.id ? this.protocols.updateProtocol(data) : this.protocols.addProtocol(data)

        this.$toastr('success', '', 'Успешно сохранено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка сохранения')
      } finally {
        this.btnLoading = false
      }
    },

    async removeProtocol() {
      try {
        this.btnLoading = true
        await protocolApi.remove(this.selectedItem.id)
        this.protocols.removeProtocol(this.selectedItem.id)
        this.$toastr('success', '', 'Успешно удалено')
        this.closeDialog()
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка удаления')
      } finally {
        this.btnLoading = false
      }
    },

    async showProtocolLines(protocol) {
      try {
        this.protocolLinesLoading = true
        this.currentProtocolApplications = []
        const data = await protocolLineApi.findAllByProtocolId(protocol.item.id)
        this.currentProtocolApplications = new ProtocolLineDtoList(data)
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка загрузки протокола')
      } finally {
        this.protocolLinesLoading = false
      }
    },

    closeDialog() {
      this.dialog = false
      this.confirmDialog = false
      this.selectedItem = null
    },
  },
}
</script>

<style scoped>
.mdi-loading {
  animation: spinner 1s linear infinite;
}

@keyframes spinner {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.protocols-table_inner {
  cursor: default;
  background: transparent;
}

.protocols-table_inner tr {
  background: transparent !important;
}
.protocols-table_inner td {
  background: transparent !important;
}
</style>
